import { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { FaPaperPlane, FaXmark } from "react-icons/fa6";
import { userServices } from "../../APIServices/userServices";
import Swal from "sweetalert2";

const ChangeEmail = ({ setActiveItem }) => {
  const [email, setEmail] = useState("");
  const [otpStatus, setOTPStatus] = useState("");
  const [otp, setOTP] = useState("");
  const [loader, setLoader] = useState("");

  const sendEmailOTP = async () => {
    setLoader(true);
    let userData = {};
    userData.email = email;
    let data = await userServices.sendEmailOTP(userData);
    if (data?.status === "otpVerification") {
      setOTPStatus(data?.status || "");
      setEmail(data?.email || email);
    }
    setLoader(false);
  };

  const updateNewEmail = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Verify and Update Email?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Verify and Update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.email = email;
        userData.otp = otp;
        let data = await userServices.updateNewEmail(userData);
        if (data?.statusCode === 200) {
          setEmail("");
          setOTPStatus("");
          setOTP("");
        }
        setLoader(false);
      }
    });
  };
  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Change Email</h5>
        <Button
          variant="outline-light"
          className="text-danger hstack gap-2 py-1 px-2 rounded-2"
          style={{ fontSize: 14 }}
          onClick={() => setActiveItem("")}
        >
          <FaXmark /> Cancel
        </Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 106px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-2 mb-3">
            <Card.Body>
              <Form.Group className="mb-2">
                <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                  New Email Address
                </Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  disabled={otpStatus === "otpVerification"}
                  onChange={(e) => setEmail(e.target.value)}
                  className="interactive-input rounded-1"
                  style={{ fontSize: 12, padding: "6px 15px" }}
                  placeholder="Enter Email Address"
                />
              </Form.Group>
              {otpStatus === "otpVerification" && (
                <Form.Group className="mb-2">
                  <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                    OTP
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={otp}
                    onChange={(e) => setOTP(e.target.value)}
                    className="interactive-input rounded-1"
                    style={{ fontSize: 12, padding: "6px 15px" }}
                    placeholder="Enter OTP"
                  />
                </Form.Group>
              )}
              <div className="hstack justify-content-end">
                {otpStatus === "otpVerification" ? (
                  <Button
                    disabled={loader || !email || !otp}
                    onClick={updateNewEmail}
                    variant="outline-primary"
                    style={{ fontSize: 13 }}
                    title="Send Confirmation"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <FaPaperPlane /> Verify and Uppdate
                  </Button>
                ) : (
                  <Button
                    disabled={loader || !email}
                    onClick={sendEmailOTP}
                    variant="outline-primary"
                    style={{ fontSize: 13 }}
                    title="Send Confirmation"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <FaPaperPlane /> Send Confirmation
                  </Button>
                )}
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ChangeEmail;
